import { ErrorCodes } from 'enums/ErrorCodes';

import { ErrorDto } from './ErrorDto';

export default class ResponseError extends Error {
  message: string;

  code: ErrorCodes;

  constructor(errorDto: ErrorDto) {
    super(errorDto.error.errorMessage);

    this.message = errorDto.error.errorMessage || '';
    this.code = errorDto.error.errorCode;
  }
}
